import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';
import useBeautyFilterImageStore from 'stores/beautyFilter/beautyFilterImageStore';
import { useMemo } from 'react';

const useBeautyFilter = () => {
  const store = useBeautyFilterStore();
  const { isBeautyFilterModalVisible, isLoading, hideBeautyFilterModal } = store;
  const { loadingImages } = useBeautyFilterImageStore();

  const handleBackgroundClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) hideBeautyFilterModal();
  };

  const showSkeletons = useMemo(() => {
    return loadingImages.size > 0;
  }, [loadingImages]);

  return {
    isBeautyFilterModalVisible,
    isLoading,
    handleBackgroundClick,
    showSkeletons,
  };
};

export default useBeautyFilter;
